// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header[data-v-b362d7a2]{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}.toolbar[data-v-b362d7a2]{display:flex;gap:8px}.item-line[data-v-b362d7a2]{font-size:12px;line-height:1.6;color:#606266}.empty-hint[data-v-b362d7a2]{margin-bottom:12px}.muted[data-v-b362d7a2]{color:#c0c4cc;font-size:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
